import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

const adminLinks = [
  { to: "/", label: "Dashboard", end: true, testid: "nav-dashboard" },
  { to: "/affiliates", label: "Affiliates", testid: "nav-affiliates" },
  { to: "/conversions", label: "Conversions", testid: "nav-conversions" },
  { to: "/products", label: "Shopify Catalog", testid: "nav-products" },
  { to: "/promoters", label: "Affiliate Access", testid: "nav-promoters" },
];

const promoterLinks = [
  { to: "/portal", label: "My Dashboard", end: true, testid: "nav-portal" },
  { to: "/portal/commissions", label: "My Commissions", testid: "nav-portal-commissions" },
];

export default function Layout({ children }) {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const links = user?.role === "promoter" ? promoterLinks : adminLinks;

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="shell">
      <aside className="sidebar" data-testid="sidebar">
        <div className="brand">Referral&nbsp;Lite</div>
        <nav className="nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testid}
              className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="admin-email" data-testid="admin-email">{user?.email}</div>
          <div className="muted small" data-testid="user-role">{user?.role}</div>
          <button className="btn btn-logout" data-testid="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </aside>
      <main className="content">{children}</main>
    </div>
  );
}
